module.exports = __webpack_public_path__ + "static/media/exclusive-active.cb4944dd.svg";